import React from "react";
import { string, objectOf, oneOfType, number, arrayOf, node } from "prop-types";
import cx from "classnames";
import * as styles from "./CardHeader.module.scss";

const CardHeader = ({ className, style, children }) => (
	<div className={cx(styles.heading, className)} style={style}>
		{children}
	</div>
);

CardHeader.propTypes = {
	children: oneOfType([arrayOf(node), node]).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),
};

CardHeader.defaultProps = {
	className: "",
	style: {},
};

export default CardHeader;
export { CardHeader };
